function Nollie() {
  return (
    <div className="dice-face face--nollie">
      <span>NOLLIE</span>
    </div>
  );
}

export default Nollie;
